import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	BuildingFormInput,
	BuildingFormOutput,
} from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";

type Props = {
	control: Control<BuildingFormInput, unknown, BuildingFormOutput>;
	isLast?: boolean;
};

const PropertyResources = Resources.PortfolioDetail.Property;
const FormResources = Resources.Portfolio.AddRealEstate;

export const BuildingValueFields = ({ control, isLast = false }: Props) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowFormInput
				control={control}
				name="marketValue"
				type="number"
				label={t(PropertyResources.MarketPrice)}
				placeholder={t(FormResources.Placeholders.fill)}
				suffix={t(Resources.Common.CurrencySign)}
			/>
			<FlatRowFormInput
				control={control}
				name="reproductionValue"
				type="number"
				label={t(PropertyResources.ReproductionPrice)}
				placeholder={t(FormResources.Placeholders.fill)}
				suffix={t(Resources.Common.CurrencySign)}
			/>
			<FlatRowFormInput
				control={control}
				name="interiorValue"
				type="number"
				label={t(PropertyResources.InteriorPrice)}
				placeholder={t(FormResources.Placeholders.fill)}
				suffix={t(Resources.Common.CurrencySign)}
				isLast={isLast}
			/>
		</>
	);
};
